export default __webpack_public_path__ + "static/becoming-sad-2c08b5bffa183ebf041675eb85e9af74.svg";